import { ADDRESS_FORM_EVENTS } from '~base';
import { NAV_EVENTS } from './clientSideNav';
import { EVENTS as CHECKOUT_EVENTS } from '../checkout/checkoutDom';
import { COLLAPSE_EVENTS } from '../thirdParty/bootstrap/toggleFormElementsStates';
import { onEvent, visible } from '../util/domutils';

const IDS = {
  LOOKUP: 'addressLookup',
  CUSTOM_LOOKUP: 'customAddressLookup',
  COUNTRY: 'country',
  ADDRESS_FIELDS: {
    LINE1: 'addressOne',
    LINE2: 'addressTwo',
    LINE3: 'addressThree',
    POSTAL_CODE: 'postalCode',
    CITY: 'city',
    STATE: 'stateCode',
  },
};

const IDS1 = {
  LOOKUP: 'addressLookup-delivery',
  CUSTOM_LOOKUP: 'customAddressLookup-delivery',
  COUNTRY: 'country',
  ADDRESS_FIELDS: {
    LINE1: '.checkout-billing__address #addressOne',
    LINE2: '.checkout-billing__address #addressTwo',
    LINE3: '.checkout-billing__address #addressThree',
    POSTAL_CODE: '.checkout-billing__address #postalCode',
    CITY: '.checkout-billing__address #city',
    STATE: '.checkout-billing__address #stateCode',
  },
};

const CLASSES = {
  ERROR: 'is-invalid',
};

const SELECTORS = {
  LOOKUP: `#${IDS.LOOKUP}`,
  CUSTOM_LOOKUP: `.${IDS.CUSTOM_LOOKUP}`,
  COUNTRY: `#${IDS.COUNTRY}`,
  ADDRESS_FIELDS: `#${Object.keys(IDS.ADDRESS_FIELDS).map(key => IDS.ADDRESS_FIELDS[key]).join(', #')}`,
  TOGGLE: '.address-lookup__footer',
  SUBMIT_BUTTON: 'button[type="submit"]',
};

const SELECTORS1 = {
  LOOKUP: `#${IDS1.LOOKUP}`,
  CUSTOM_LOOKUP: `.${IDS1.CUSTOM_LOOKUP}`,
  COUNTRY: `#${IDS1.COUNTRY}`,
  ADDRESS_FIELDS: `${Object.keys(IDS1.ADDRESS_FIELDS).map(key => IDS1.ADDRESS_FIELDS[key]).join(', ')}`,
  TOGGLE: '.address-lookup__footer',
  SUBMIT_BUTTON: 'button[type="submit"]',
};

const showAddressFields = () => {
  document.querySelectorAll(SELECTORS.ADDRESS_FIELDS).forEach((el) => {
    el.disabled = false;
    el.parentElement.parentElement.classList.remove('d-none');
  });
};

const showAddressFieldsOnReinit = () => {
  setTimeout(() => {
    const fields = Array.from(document.querySelectorAll(SELECTORS.ADDRESS_FIELDS));
    const hasValues = fields.some(field => !!field.value);
    const hasErrors = fields.some(field => field.classList.contains(CLASSES.ERROR));

    if (hasValues || hasErrors) {
      showAddressFields();
    }
  }, 1);
};

const createControl = (lookupField, fields) => {
  const control = new window.pca.Address(fields, {
    key: lookupField.dataset.key,
    suppressAutocomplete: false,
  });
  control.listen('populate', (address) => {
    lookupField.value = address.Label.replace(/\n/g, ' ');

    if (fields.length > 1) {
      showAddressFields();
    }
    const fieldValueMap = {
      Line1: { selector: '#addressOne', value: address.FormattedLine1 },
      Line2: { selector: '#addressTwo', value: address.FormattedLine2 },
      Line3: { selector: '#addressThree', value: address.FormattedLine3 },
      PostalCode: { selector: '#postalCode', value: address.PostalCode },
      City: { selector: '#city', value: address.Province },
    };

    fields.forEach(({ field }) => {
      const fieldData = fieldValueMap[field];
      if (fieldData) {
        // eslint-disable-next-line jquery/no-val, no-undef
        $(`.checkout-billing__address ${fieldData.selector}`).val(fieldData.value);
      }
    });
    document.dispatchEvent(new CustomEvent(ADDRESS_FORM_EVENTS.POPULATE));
    document.dispatchEvent(new CustomEvent(ADDRESS_FORM_EVENTS.UPDATE));
    // eslint-disable-next-line jquery/no-class, no-undef
    if (!$('.address-fields__field').hasClass('addressLookup-billing')) {
      document.dispatchEvent(new CustomEvent(ADDRESS_FORM_EVENTS.REFRESH));
    }
  });

  return control;
};

const initAddressSearch = (selector, ids) => {
  const lookupField = document.querySelector(selector.LOOKUP);
  const customLookupFields = document.querySelectorAll(selector.CUSTOM_LOOKUP);

  if (lookupField) {
    const fields = [
      { element: ids.LOOKUP, field: '', mode: window.pca.fieldMode.SEARCH },
      { element: ids.COUNTRY, field: 'Country', mode: window.pca.fieldMode.PRESERVE },
      { element: ids.ADDRESS_FIELDS.LINE1, field: 'Line1', mode: window.pca.fieldMode.POPULATE },
      { element: ids.ADDRESS_FIELDS.LINE2, field: 'Line2', mode: window.pca.fieldMode.POPULATE },
      { element: ids.ADDRESS_FIELDS.LINE3, field: 'Line3', mode: window.pca.fieldMode.POPULATE },
      { element: ids.ADDRESS_FIELDS.POSTAL_CODE, field: 'PostalCode', mode: window.pca.fieldMode.POPULATE },
      { element: ids.ADDRESS_FIELDS.CITY, field: 'City', mode: window.pca.fieldMode.POPULATE },
      { element: ids.ADDRESS_FIELDS.STATE, field: 'ProvinceName', mode: window.pca.fieldMode.POPULATE },
    ];

    const control = createControl(lookupField, fields);

    control.listen('results', (results) => {
      let i;
      let isContainPostAddress;
      for (i = 0; i < results.length; i++) {
        isContainPostAddress = typeof results[i] !== 'undefined'
          && (results[i].Text.toUpperCase().indexOf('PO BOX') !== -1
          || results[i].Text.toUpperCase().indexOf('BFPO') !== -1);
        if (isContainPostAddress) {
          results.splice(i);
        }
      }
    });

    control.listen('load', () => {
      control.setCountry(document.querySelector(selector.COUNTRY).value);
    });


    control.load(); // Forces the 'load' event to be fired, it seems to be skipped on occasion
  }

  customLookupFields.forEach((customLookupField) => {
    const customFields = [
      { element: customLookupField, field: 'search', mode: window.pca.fieldMode.DEFAULT },
    ];

    createControl(customLookupField, customFields);
  });
};

export const initLookup = () => {
  // Set an interval to make sure window.pca is defined
  const pcaInterval = setInterval(() => {
    if (window.pca) {
      clearInterval(pcaInterval);
      initAddressSearch(SELECTORS, IDS);
      initAddressSearch(SELECTORS1, IDS1);

      onEvent(document, 'click', SELECTORS.TOGGLE, () => {
        showAddressFields();
      });

      [
        COLLAPSE_EVENTS.FORMS_STATE_CHANGED,
      ].forEach((evt) => {
        document.addEventListener(evt, () => {
          document.querySelectorAll(SELECTORS.ADDRESS_FIELDS).forEach((el) => {
            const toggle = document.querySelector(SELECTORS.TOGGLE);

            if (visible(toggle)) {
              el.disabled = false;
            }
          });
        });
      });

      [
        ADDRESS_FORM_EVENTS.REFRESH,
        CHECKOUT_EVENTS.SAVED_ADDRESS.ADDRESS_SELECTED,
        CHECKOUT_EVENTS.BILLING.USE_SHIPPING_AS_BILLING_TOGGLED,
        NAV_EVENTS.NAV_CONTENT,
        NAV_EVENTS.NAV_BACK,
      ].forEach((evt) => {
        document.addEventListener(evt, (e) => {
          initAddressSearch(SELECTORS, IDS);
          initAddressSearch(SELECTORS1, IDS1);

          if (e.detail && e.detail.error) {
            showAddressFields();
          }
        });
      });

      document.addEventListener(ADDRESS_FORM_EVENTS.SUBMIT, showAddressFieldsOnReinit);

      showAddressFieldsOnReinit();
    }
  }, 100);
};

export * from '~base';
